// locations a robot might be
export const PANEL = {};
export const STAGE = {};

export const GAME_STATES = {
  FILLING_STAGE: 'filling',
  PLAYING_SEQUENCE: 'playing',
  REPEATING_SEQUENCE: 'repeating',
  SEQUENCE_SUCCESS: 'sequence success',

  // in this state, all robots cheer
  // wait for user to either hit "replay" button
  // or change level
  LEVEL_SUCCESS: 'level success',

  // show failure indication,
  // wait for user to either hit "replay" button
  // or change level
  FAILURE: 'failure',
};


// WEBPACK FOOTER //
// ./src/AppConstants.js